<div *ngIf="managedCommand">
  <form (ngSubmit)="save()" #form="ngForm" role="form" class="vbox full-width">
    <div class="stick-top">
      <mat-toolbar>
        <mat-icon>terminal</mat-icon>
        {{!managedCommand.id ? 'Create new Managed Command' : ('Managed Command ' + managedCommand.name)}}
      </mat-toolbar>
      <div class="hbox lightly-padded button-bar">
        <button mat-raised-button class="primary" type="submit" [disabled]="!form.form.valid">
          <mat-icon>{{!managedCommand.id ? 'add' : 'save'}}</mat-icon>
          {{managedCommand.id ? 'Update' : 'Add'}}
        </button>
        <micro-delete-confirm *ngIf="managedCommand.id" (onConfirm)="delete()"></micro-delete-confirm>
      </div>
    </div>

    <mat-tab-group>
      <mat-tab label="Settings">
        <mat-toolbar><mat-icon>settings</mat-icon> Settings</mat-toolbar>
        <div class="padded hbox" style="align-items: stretch; gap: 10px;">
          <table class="basicTable">
            <thead>
            <tr>
              <th colspan="100">Basic Settings</th>
            </tr>
            <tr>
              <th *ngIf="auth.isSystemUser()">Company</th>
              <th style="width: 140px;">Name</th>
              <th style="width: 120px;">Code</th>
              <th style="width: 80px;">Timeout (ms)</th>
              <th style="width: 100px;">Log Retention (hrs)</th>
              <th style="width: 86px;">Type</th>
              <th style="width: 50px;" [ngClass]="!managedCommand.enabled ? 'WARNING' : ''">Enabled</th>
              <th style="width: 70px;" [ngClass]="managedCommand.collectData ? 'CRITICAL' : ''" matTooltip="Experimental feature">Collect Data</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td *ngIf="auth.isSystemUser()">
                <micro-company-select #companyId="ngModel"
                                      [(ngModel)]="managedCommand.companyId"
                                      [required]="true"
                                      [jump]="false"
                                      id="companyId"
                                      name="companyId">
                </micro-company-select>
              </td>
              <td><input [(ngModel)]="managedCommand.name" required maxlength="50" placeholder="Name" id="name" name="name"></td>
              <td><input [(ngModel)]="managedCommand.code" required maxlength="32" placeholder="Code" id="code" name="code"></td>
              <td><input type="number" min="0" [(ngModel)]="managedCommand.timeout" required placeholder="Timeout (ms)" id="timeout" name="timeout"></td>
              <td><input type="number" min="1" [(ngModel)]="managedCommand.logRetentionHours" placeholder="Log Retention (hrs)" id="logRetentionHours" name="logRetentionHours"></td>
              <td>
                <micro-serviceType-select [(serviceType)]="managedCommand.commandType"
                                          (serviceTypeChange)="onCommandTypeChange()"
                                          [required]="true">
                </micro-serviceType-select>
              </td>
              <td><input type="checkbox" [(ngModel)]="managedCommand.enabled" id="enabled" name="enabled"></td>
              <td><input type="checkbox" [(ngModel)]="managedCommand.collectData" id="collectData" name="collectData"></td>
            </tr>
            <tr *ngIf="managedCommand.id">
              <th colspan="2">Created</th>
              <td colspan="6">
                <micro-user-lookup [userId]="managedCommand.createdBy"></micro-user-lookup>
                on {{managedCommand.createdDate | dateTime}}
              </td>
            </tr>
            <tr>
              <td colspan="100">
                <micro-objectGroup-picklist type="MANAGED_COMMAND" [(selectedItems)]="managedCommand.cmdGroups"></micro-objectGroup-picklist>
              </td>
            </tr>
            </tbody>
          </table>
          <micro-list-box title="Known Variables"
                          [items]="variables"
                          [values]="variableValues"
                          itemHeader="Variable"
                          valueHeader="Test Value"
                          [fillHeight]="true"
                          [listSize]="20"
                          [emptyText]="variableHelpText"
                          style="width: 280px;">
          </micro-list-box>
        </div>
      </mat-tab>

      <mat-tab label="Command">
        <mat-toolbar>Command</mat-toolbar>
        <div class="padded hbox" style="align-items: stretch; gap: 10px;">
          <table class="basicTable" style="flex: 1 1 600px; min-width: 0;">
            <thead>
            <tr>
              <th colspan="100">Command Configuration</th>
            </tr>
            </thead>
            <tbody>
            <ng-container *ngIf="managedCommand.commandType !== 'HTTP'">
              <tr *ngIf="managedCommand.commandType === 'COMMAND'">
                <td colspan="100">
                  <code style="font-family: monospace">[cmd exec] command[@connection] [var...]</code><br/>
                  <code style="font-family: monospace">command: (commandCode | !commandId)</code><br/>
                  <code style="font-family: monospace">connection: (connectionName | !connectionId)</code><br/>
                  <code style="font-family: monospace">var: varName=varValue</code><br/>
                  The <code style="font-family: monospace">cmd exec</code> prefix is optional.<br/>
                  Invoke a managed command by code or ID.<br/>
                  For commands that require a service connection, append connection name or ID.<br/>
                  Variables can be added to the command or supplied from the Command Parameters.</td>
              </tr>
              <tr>
                <th colspan="100"><micro-valid-label for="editorCommand" [model]="managedCommand.command" label="Command"></micro-valid-label></th>
              </tr>
              <tr>
                <td colspan="100">
                  <micro-ace-editor #editorCommand="ngModel"
                                    class="mono"
                                    style="height: 400px;width: 100%;"
                                    [required]="true"
                                    [(ngModel)]="managedCommand.command"
                                    (ngModelChange)="refreshVariables()"
                                    [mode]="getCmdEditMode()"
                                    [canFullscreen]="true"
                                    name="editorCommand"
                                    id="editorCommand">
                  </micro-ace-editor>
                </td>
              </tr>
            </ng-container>

            <ng-container *ngIf="managedCommand.commandType === 'HTTP'">
              <tr>
                <th colspan="100">HTTP Command</th>
              </tr>
              <tr>
                <td><b>HTTP Method</b></td>
                <td><micro-http-method-select [(method)]="webClientCommand.method" [required]="true"></micro-http-method-select></td>
              </tr>
              <tr>
                <td><b>URL Path</b></td>
                <td><input [(ngModel)]="webClientCommand.urlPath" (ngModelChange)="refreshVariables()" required placeholder="URL path" id="urlPath" name="urlPath"></td>
              </tr>
            </ng-container>

            <tr>
              <th colspan="100">{{managedCommand.commandType === 'HTTP' ? 'Query' : 'Command'}} Parameters</th>
            </tr>
            <tr>
              <th>Name</th>
              <th>Value</th>
              <th></th>
            </tr>
            <tr *ngFor="let arg of commandArgs; let i = index">
              <td><input [(ngModel)]="arg.name" [name]="'commandArg_name_' + i"></td>
              <td><input [(ngModel)]="arg.value" (ngModelChange)="refreshVariables()" [name]="'commandArg_value_' + i"></td>
              <td><button type="button" (click)="removeCommandArg(i)">Remove</button></td>
            </tr>
            <tr>
              <td><input placeholder="Name" [(ngModel)]="newCommandArg.name" name="newCommandArg_name"></td>
              <td><input placeholder="Value" [(ngModel)]="newCommandArg.value" name="newCommandArg_value"></td>
              <td><button type="button" (click)="addCommandArg()" [disabled]="!newCommandArg.name">Add</button></td>
            </tr>

            <ng-container *ngIf="managedCommand.commandType === 'HTTP'">
              <tr>
                <th colspan="100">Request Content</th>
              </tr>
              <tr>
                <td><b>Request Content Type</b></td>
                <td>
                  <select [(ngModel)]="webClientCommand.requestContentType" id="requestContentType" name="requestContentType">
                    <option value="NONE">No Request Content</option>
                    <option value="json">JSON</option>
                    <option value="xml">XML</option>
                    <option value="text">Text</option>
                  </select>
                </td>
              </tr>
              <tr *ngIf="webClientCommand.requestContentType !== 'NONE'">
                <td colspan="100">
                  <micro-ace-editor #editorWebCommand="ngModel"
                                    class="mono"
                                    style="height: 400px;width: 100%;"
                                    [(ngModel)]="webClientCommand.command"
                                    (ngModelChange)="refreshVariables()"
                                    [mode]="webClientCommand.requestContentType"
                                    [canFullscreen]="true"
                                    name="editorWebCommand"
                                    id="editorWebCommand">
                  </micro-ace-editor>
                </td>
              </tr>
              <tr>
                <th colspan="100">HTTP Headers</th>
              </tr>
              <tr>
                <th>Name</th>
                <th>Value</th>
                <th></th>
              </tr>
              <tr *ngFor="let header of httpHeaders; let i = index">
                <td><input [(ngModel)]="header.name" [name]="'httpHeader_name_' + i"></td>
                <td><input [(ngModel)]="header.value" (ngModelChange)="refreshVariables()" [name]="'httpHeader_value_' + i"></td>
                <td><button type="button" (click)="removeHttpHeader(i)">Remove</button></td>
              </tr>
              <tr>
                <td><input placeholder="Name" [(ngModel)]="newHttpHeader.name" name="newHttpHeader_name"></td>
                <td><input placeholder="Value" [(ngModel)]="newHttpHeader.value" name="newHttpHeader_value"></td>
                <td><button type="button" (click)="addHttpHeader()" [disabled]="!newHttpHeader.name">Add</button></td>
              </tr>
            </ng-container>

            <ng-container *ngIf="hasTransform()">
              <tr>
                <th colspan="100">Transform</th>
              </tr>
              <tr>
                <td colspan="100"><micro-transform-select [(transformId)]="managedCommand.transform"
                                                             [required]="true"
                                                             (transformIdChange)="onTransformChange()">
                </micro-transform-select></td>
              </tr>
              <tr *ngFor="let arg of transformArgs; let i = index">
                <td [matTooltip]="arg.description">{{arg.name}}</td>
                <td [matTooltip]="arg.description">
                  <input [(ngModel)]="arg.value"
                         [name]="'transformArg_value_' + arg.name"
                         [placeholder]="arg.defaultValue">
                </td>
                <td></td>
              </tr>
            </ng-container>
            </tbody>
          </table>
          <micro-list-box title="Known Variables"
                          [items]="variables"
                          [values]="variableValues"
                          itemHeader="Variable"
                          valueHeader="Test Value"
                          [fillHeight]="true"
                          [listSize]="20"
                          [emptyText]="variableHelpText"
                          style="width: 280px;">
          </micro-list-box>
        </div>

        <ng-container [ngTemplateOutlet]="testCommandPanel"></ng-container>
      </mat-tab>

      <mat-tab label="Response Script">
        <mat-toolbar class="stick-top">Response Script</mat-toolbar>
        <div class="padded hbox" style="align-items: stretch; gap: 10px;">
          <table class="basicTable" style="flex: 1 1 600px; min-width: 0;">
            <thead>
            <tr><th>Response Script</th></tr>
            </thead>
            <tbody>
            <tr>
              <td>
                <micro-ace-editor #editorResponseScript="ngModel"
                                  class="mono"
                                  style="height: 400px;width: 100%;"
                                  [(ngModel)]="managedCommand.script"
                                  (ngModelChange)="refreshVariables()"
                                  mode="groovy"
                                  [canFullscreen]="true"
                                  name="editorResponseScript"
                                  id="editorResponseScript">
                </micro-ace-editor>
              </td>
            </tr>
            </tbody>
          </table>
          <micro-list-box title="Known Variables"
                          [items]="variables"
                          [values]="variableValues"
                          itemHeader="Variable"
                          valueHeader="Test Value"
                          [fillHeight]="true"
                          [listSize]="20"
                          [emptyText]="variableHelpText"
                          style="width: 280px;">
          </micro-list-box>
        </div>
        <ng-container [ngTemplateOutlet]="testCommandPanel"></ng-container>
      </mat-tab>

      <mat-tab label="Alarming">
        <mat-toolbar class="stick-top">Alarm Template</mat-toolbar>
        <table class="dataTable">
          <thead>
          <tr>
            <th>Severity</th>
            <th>NW.TYPE</th>
            <th>MOC</th>
            <th>MOI</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              <select required [(ngModel)]="managedCommand.alarmSeverity" name="alarmSeverity">
                <option value="CLEARED">CLEARED</option>
                <option value="INFO">INFO</option>
                <option value="MINOR">MINOR</option>
                <option value="WARNING">WARNING</option>
                <option value="MAJOR">MAJOR</option>
                <option value="CRITICAL">CRITICAL</option>
                <option value="INTERMEDIATE">INTERMEDIATE</option>
              </select>
            </td>
            <td><micro-net-select [(netId)]="managedCommand.alarmNetId" [required]="true"></micro-net-select></td>
            <td><micro-moc-select [(mocId)]="managedCommand.alarmMocId" [netId]="managedCommand.alarmNetId" [required]="true"></micro-moc-select></td>
            <td><input [(ngModel)]="managedCommand.alarmMoInst" required maxlength="50" placeholder="Managed Object Instance" id="alarmMoInst" name="alarmMoInst"></td>
          </tr>
          <tr>
            <th>Spec.Prob</th>
            <th>Prob.Cause</th>
            <th>Rep.Acts</th>
            <th>Event Type</th>
          </tr>
          <tr>
            <td>
              <micro-specProb-select [(specProbId)]="managedCommand.alarmSpecProbId"
                                     [mocId]="managedCommand.alarmMocId"
                                     (specProbIdChange)="reloadSpecProb()"
                                     [required]="true">
              </micro-specProb-select>
            </td>
            <td>{{specProb?.probCause || '--Spec.Prob--'}}</td>
            <td>{{specProb?.repActs || '--Spec.Prob--'}}</td>
            <td><input [(ngModel)]="managedCommand.alarmEvtType" maxlength="50" placeholder="Event Type" id="alarmEvtType" name="alarmEvtType"></td>
          </tr>
          <tr>
            <th colspan="2">Site ID</th>
            <th colspan="2">Additional Text</th>
          </tr>
          <tr>
            <td colspan="2"><input [(ngModel)]="managedCommand.alarmSiteId" maxlength="45" placeholder="Site ID" id="alarmSiteId" name="alarmSiteId"></td>
            <td colspan="2"><textarea style="width: 100%;" rows="8" [(ngModel)]="managedCommand.alarmAddText" placeholder="Additional Text" id="alarmAddText" name="alarmAddText"></textarea></td>
          </tr>
          </tbody>
        </table>
      </mat-tab>

      <mat-tab *ngIf="managedCommand.id" label="Log">
        <ng-template matTabContent>
          <micro-managed-command-log [managedCommand]="managedCommand"></micro-managed-command-log>
        </ng-template>
      </mat-tab>

      <mat-tab *ngIf="managedCommand.id" label="History">
        <ng-template matTabContent>
          <micro-audits objectType="ManagedCommand" [objectId]="managedCommand.id"></micro-audits>
        </ng-template>
      </mat-tab>
    </mat-tab-group>

    <ng-template #testCommandPanel>
      <mat-toolbar>Test Command</mat-toolbar>
      <div class="padded">
        <table class="basicTable">
          <thead>
          <tr>
            <th *ngIf="managedCommand.commandType !== 'COMMAND'">Target</th>
            <th>Run</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td *ngIf="managedCommand.commandType !== 'COMMAND'">
              <micro-cmd-service-select [serviceType]="managedCommand.commandType"
                                        [(serviceId)]="testTargetId"
                                        [required]="true">
              </micro-cmd-service-select>
            </td>
            <td>
              <button mat-raised-button class="primary" type="button"
                      [disabled]="gettingTestCommandResult || (managedCommand.commandType !== 'COMMAND' && !testTargetId) || !form.form.valid"
                      (click)="testCommand()">
                Test Command
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <mat-progress-bar *ngIf="gettingTestCommandResult" mode="indeterminate"></mat-progress-bar>

      <div *ngIf="testCommandResult">
        <mat-toolbar>Test Results</mat-toolbar>
        <div class="padded">
          <table class="basicTable" style="width: 100%;">
            <thead>
            <tr>
              <th>Status</th>
              <th>Message</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td [ngClass]="testCommandResult.success ? '' : 'CRITICAL'">{{testCommandResult.success ? 'Success' : 'Failed'}}</td>
              <td>{{testCommandResult.commandResponse?.error || testCommandResult.message}}</td>
            </tr>
            </tbody>
          </table>

          <table *ngIf="hasTestResultVariables()" class="basicTable" style="width: 100%;">
            <thead>
            <tr><th>Variables</th></tr>
            </thead>
            <tbody>
            <tr>
              <td><micro-object-grid [data]="testCommandResult.vars"></micro-object-grid></td>
            </tr>
            </tbody>
          </table>
          <table *ngIf="testCommandResult.commandResponse" class="basicTable managed-command-results-table" style="width: 100%; table-layout: fixed;">
            <colgroup>
              <col style="width: 90px;">
              <col>
            </colgroup>
            <thead>
            <tr>
              <th>Type</th>
              <th>Content</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>cmdRsp</td>
              <td>
                <div *ngIf="testCommandResult.commandResponse?.cmdRsp" class="managed-command-json-viewer" tabindex="0">
                  <ngx-json-viewer class="mono"
                                   [depth]="1"
                                   [json]="testCommandResult.commandResponse?.cmdRsp">
                  </ngx-json-viewer>
                </div>
                <span *ngIf="!testCommandResult.commandResponse?.cmdRsp" class="mono">Empty</span>
              </td>
            </tr>
            <tr>
              <td>scriptRsp</td>
              <td>
                <div *ngIf="testCommandResult.commandResponse?.scriptRsp" class="managed-command-json-viewer" tabindex="0">
                  <ngx-json-viewer class="mono"
                                   [depth]="1"
                                   [json]="testCommandResult.commandResponse?.scriptRsp">
                  </ngx-json-viewer>
                </div>
                <span *ngIf="!testCommandResult.commandResponse?.scriptRsp" class="mono">Empty</span>
              </td>
            </tr>
            <tr>
              <td>scriptLog</td>
              <td>
                <textarea *ngIf="testCommandResult.commandResponse?.scriptLog" style="min-width: 350px; min-height: 100px;"
                            [value]="testCommandResult.commandResponse?.scriptLog"
                            [readOnly]="true"
                            name="scriptLog">
                </textarea>
                <textarea *ngIf="!testCommandResult.commandResponse?.scriptLog" style="min-width: 350px; min-height: 100px;"
                          [value]="'No script log'"
                          [readOnly]="true"
                          name="scriptLog">
                </textarea>
              </td>
            </tr>
            </tbody>
          </table>

        </div>
      </div>
    </ng-template>
  </form>
</div>
